import { breakpoints, customScrollMinimal } from '@toggle/design-system';
import styled from 'styled-components';

import { BaseErrorView } from '~/components/base-error-view/BaseErrorView';

const INSIGHTS_LIST_OFFSET = 571; // Header + footer + padding heights

export const Cards = styled.div`
  @media ${breakpoints.xlg} {
    max-height: calc(100vh - ${INSIGHTS_LIST_OFFSET}px);
    overflow: scroll;
    scrollbar-gutter: auto;
    ${customScrollMinimal};
  }
`;

export const StyledBaseErrorView = styled(BaseErrorView)`
  max-height: 200px;
  border-bottom: 1px solid var(--border-soft);
`;
